import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=9bf74b68&scoped=true&lang=pug"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=9bf74b68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf74b68",
  null
  
)

export default component.exports